import { render, staticRenderFns } from "./ChatWorkbench.vue?vue&type=template&id=769a0ac3&scoped=true"
import script from "./ChatWorkbench.vue?vue&type=script&lang=js"
export * from "./ChatWorkbench.vue?vue&type=script&lang=js"
import style0 from "./ChatWorkbench.vue?vue&type=style&index=0&id=769a0ac3&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "769a0ac3",
  null
  
)

export default component.exports